import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from "../../graphqlsupport";
import {useCallback} from "react";
import { showToast } from 'common/component/NotificationToaster';

export const MARK_PROVIDER_EVENTS_AS_READ = gql`
    mutation ($providerEventGuids: [UUID!] ){
        markProviderEventsAsRead(providerEventGuids: $providerEventGuids)
    }
`;

type MarkProviderEventsAsReadInput = {
    providerEventGuids: string[],
}

export const useMarkProviderEventsAsRead = (
    successCallback: () => void,
) => {
    const {
        isRunning$,
        execute,
    } = useMutation$<MarkProviderEventsAsReadInput, void>(MARK_PROVIDER_EVENTS_AS_READ);

    const markProviderEventsAsRead = useCallback(async (providerEventGuids: string[]) => {
        try {
            const {data: result,} = await execute({
                variables: {
                    providerEventGuids: providerEventGuids,
                }
            });
            if (result) {
                successCallback();
                showToast.success(`Notification mark as read`);
            }
        } catch (e: any) {
            showToast.error(getDomainGraphqlError(e) ?? `Unable to mark notification as read: ${e.message || e[0].message}`);
        }
    }, [execute, successCallback]);


    return {
        isRunning$,
        execute: markProviderEventsAsRead,
    };
};
